import {UPDATE_PLAYER_LIMIT, UPDATE_PLAYER_LIMITS, UPDATE_SESSION_REMINDER} from "Redux/actions/limits";
import {LIMIT_PERIODS} from "Constants/rg";

const limitsReducer = (state = {isLoaded: false}, action) => {
    switch (action.type) {
        case UPDATE_PLAYER_LIMITS: {
            // The account object reports every limit the player holds, so a period missing from it
            // has been removed. Without clearing those keys the shallow merge below would keep a
            // just-deleted limit alive in the store.
            const clearedPeriods = {};
            LIMIT_PERIODS.forEach(period => {
                if (!(period in action.newPlayerLimits)) clearedPeriods[period] = null;
            });

            return {...state, isLoaded: true, ...clearedPeriods, ...action.newPlayerLimits};
        }
        case UPDATE_PLAYER_LIMIT:
            if (state.isLoaded) {
                return Object.assign({}, state, {
                    depositLimitsConfirmed: true,
                    [action.interval]: action.setting
                });
            }

            return state;
        case UPDATE_SESSION_REMINDER:
            if (state.isLoaded) {
                return Object.assign({}, state, {
                    sessionReminder: {
                        ...state.sessionReminder,
                        activeValue: action.interval
                    }
                });
            }

            return state;
        default:
            return {...state};
    }
};

export default limitsReducer;
